// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.recommendations {
  position: relative;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: visible;
  margin-top: 20px;
  /* Tablet screens (≤1024px) */
  /* Mobile screens (≤767px) */
  /* Very small screens (≤576px) */
}
.recommendations .section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  position: relative;
}
.recommendations .section-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}
.recommendations .section-header p {
  font-size: 16px;
  color: #64748b;
  margin: 4px 0 0;
}
.recommendations .recommendations-tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 8px;
}
.recommendations .recommendations-tabs .tab-button {
  padding: 8px 16px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}
.recommendations .recommendations-tabs .tab-button:hover {
  color: #2563eb;
}
.recommendations .recommendations-tabs .tab-button.active {
  color: #2563eb;
  font-weight: 600;
}
.recommendations .recommendations-tabs .tab-button.active::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #2563eb;
}
.recommendations .topics-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.recommendations .topic-card {
  width: 100%;
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.recommendations .topic-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}
.recommendations .topic-card .topic-card-body {
  padding: 20px;
}
.recommendations .topic-card .topic-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}
.recommendations .topic-card .topic-header .topic-name {
  font-size: 20px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  max-width: 60%;
}
.recommendations .topic-card .topic-header .completion-info {
  display: flex;
  align-items: center;
  gap: 15px;
  min-width: 200px;
}
.recommendations .topic-card .topic-header .completion-info .completion-badge {
  background-color: #f8f9fa;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  color: #7f8c8d;
  white-space: nowrap;
}
.recommendations .topic-card .topic-header .completion-info .completion-badge.champion {
  background-color: #e8f5e9;
  color: #2e7d32;
  font-weight: 600;
}
.recommendations .topic-card .topic-header .completion-info .progress-container {
  flex: 1 1;
  min-width: 100px;
  height: 10px;
  background-color: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.recommendations .topic-card .topic-header .completion-info .progress-container .progress-fill {
  height: 100%;
  background: #3498db;
  border-radius: 5px;
  transition: width 0.5s ease-in-out;
}
.recommendations .topic-card .topic-header .completion-info .progress-container .progress-fill.champion {
  background: #2e7d32;
}
.recommendations .topic-card .content-sections .content-section {
  margin-bottom: 15px;
}
.recommendations .topic-card .content-sections .content-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.recommendations .topic-card .content-sections .content-section .section-header:hover {
  background-color: #f0f0f0;
}
.recommendations .topic-card .content-sections .content-section .section-header .section-title h4 {
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
  margin: 0;
}
.recommendations .topic-card .content-sections .content-section .section-header .section-toggle .toggle-icon {
  color: #7f8c8d;
  transition: transform 0.3s ease;
}
.recommendations .topic-card .content-sections .content-section .items-container {
  margin-top: 10px;
  padding: 0 10px;
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #3498db #f0f0f0;
}
.recommendations .topic-card .content-sections .content-section .items-container::-webkit-scrollbar {
  width: 6px;
}
.recommendations .topic-card .content-sections .content-section .items-container::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}
.recommendations .topic-card .content-sections .content-section .items-container::-webkit-scrollbar-thumb {
  background: #3498db;
  border-radius: 3px;
}
.recommendations .topic-card .content-sections .content-section .items-container .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.recommendations .topic-card .content-sections .content-section .items-container .item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #3498db;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1;
  min-width: 0;
  margin-right: 20px;
}
@media (max-width: 767px) {
  .recommendations .topic-card .content-sections .content-section .items-container .item .item-details {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    margin-right: 0;
  }
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .item-name {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}
@media (max-width: 767px) {
  .recommendations .topic-card .content-sections .content-section .items-container .item .item-details .item-name {
    width: 100%;
    text-align: center;
  }
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .item-type {
  display: flex;
  align-items: center;
  gap: 8px;
}
@media (max-width: 767px) {
  .recommendations .topic-card .content-sections .content-section .items-container .item .item-details .item-type {
    justify-content: center;
  }
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .item-type .type-icon {
  font-size: 18px;
  color: #3498db;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .item-type .type-label {
  font-size: 14px;
  color: #7f8c8d;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .priority-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .priority-badge.high {
  background-color: #fee2e2;
  color: #dc2626;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .priority-badge.medium {
  background-color: #fef3c7;
  color: #d97706;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .priority-badge.low {
  background-color: #e0f2fe;
  color: #0284c7;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .score-badge {
  font-size: 14px;
  color: #7f8c8d;
  white-space: nowrap;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .item-details .score-badge.champion {
  color: #2e7d32;
  font-weight: 600;
}
.recommendations .topic-card .content-sections .content-section .items-container .item .action-button {
  min-width: 100px;
  white-space: nowrap;
}
@media (max-width: 767px) {
  .recommendations .topic-card .content-sections .content-section .items-container .item .action-button {
    width: 100%;
    margin-top: 10px;
  }
}
.recommendations .filters-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.recommendations .filters-container .filter-section .filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 10px;
}
.recommendations .filters-container.mobile-filters {
  grid-template-columns: 1fr;
  gap: 15px;
  padding: 15px;
}
.recommendations .priority-filter,
.recommendations .type-filter,
.recommendations .attempt-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.recommendations .priority-filter .filter-button,
.recommendations .type-filter .filter-button,
.recommendations .attempt-filter .filter-button {
  padding: 8px 16px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.recommendations .priority-filter .filter-button:hover,
.recommendations .type-filter .filter-button:hover,
.recommendations .attempt-filter .filter-button:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
  transform: translateY(-1px);
}
.recommendations .priority-filter .filter-button.active,
.recommendations .type-filter .filter-button.active,
.recommendations .attempt-filter .filter-button.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}
.recommendations .champion-topics .topics-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.recommendations .champion-topics .topic-card .items-container {
  scrollbar-color: #2e7d32 #f0f0f0;
}
.recommendations .champion-topics .topic-card .items-container::-webkit-scrollbar-thumb {
  background: #2e7d32;
}
.recommendations .champion-topics .topic-card .items-container .item:hover {
  border-color: #2e7d32;
}
.recommendations .champion-topics .topic-card .items-container .item .action-button {
  border-color: #2e7d32;
  color: #2e7d32;
}
.recommendations .champion-topics .topic-card .items-container .item .action-button:hover {
  background: #2e7d32;
  color: white;
  box-shadow: 0 4px 8px rgba(46, 125, 50, 0.2);
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@media (max-width: 1024px) {
  .recommendations {
    padding: 15px;
    max-width: 100%;
  }
  .recommendations .section-header {
    margin-bottom: 20px;
  }
  .recommendations .section-header h2 {
    font-size: 20px;
  }
  .recommendations .section-header p {
    font-size: 14px;
  }
  .recommendations .recommendations-tabs {
    gap: 12px;
    margin-bottom: 20px;
  }
  .recommendations .recommendations-tabs .tab-button {
    padding: 6px 12px;
    font-size: 14px;
  }
  .recommendations .filters-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    padding: 15px;
  }
  .recommendations .topic-card .topic-card-body {
    padding: 15px;
  }
  .recommendations .topic-card .topic-header .topic-name {
    font-size: 18px;
    max-width: 50%;
  }
  .recommendations .topic-card .topic-header .completion-info {
    min-width: 150px;
    gap: 10px;
  }
  .recommendations .topic-card .topic-header .completion-info .completion-badge {
    font-size: 12px;
    padding: 4px 8px;
  }
  .recommendations .topic-card .topic-header .completion-info .progress-container {
    min-width: 80px;
    height: 8px;
  }
  .recommendations .topic-card .content-sections .section-header {
    padding: 8px;
  }
  .recommendations .topic-card .content-sections .section-header .section-title h4 {
    font-size: 14px;
  }
  .recommendations .topic-card .content-sections .items-container .item {
    padding: 12px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details {
    gap: 10px;
    margin-right: 15px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-name {
    font-size: 13px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-type {
    margin-right: 10px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-type .type-icon {
    font-size: 16px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-type .type-label {
    font-size: 12px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .priority-badge,
  .recommendations .topic-card .content-sections .items-container .item .item-details .score-badge {
    font-size: 11px;
    padding: 3px 6px;
  }
  .recommendations .topic-card .content-sections .items-container .item .action-button {
    padding: 6px 12px;
    font-size: 13px;
  }
}
@media (max-width: 767px) {
  .recommendations {
    padding: 12px;
  }
  .recommendations .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 16px;
  }
  .recommendations .section-header h2 {
    font-size: 18px;
  }
  .recommendations .section-header p {
    font-size: 13px;
  }
  .recommendations .recommendations-tabs {
    gap: 8px;
    margin-bottom: 16px;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .recommendations .recommendations-tabs::-webkit-scrollbar {
    display: none;
  }
  .recommendations .recommendations-tabs .tab-button {
    padding: 6px 10px;
    font-size: 13px;
    white-space: nowrap;
  }
  .recommendations .recommendations-tabs .tab-button.active::after {
    bottom: -8px;
  }
  .recommendations .filters-container {
    padding: 12px;
  }
  .recommendations .filters-container .filter-section .filter-label {
    font-size: 13px;
    margin-bottom: 8px;
  }
  .recommendations .filters-container .filter-section .priority-filter,
  .recommendations .filters-container .filter-section .type-filter,
  .recommendations .filters-container .filter-section .attempt-filter {
    gap: 6px;
  }
  .recommendations .filters-container .filter-section .priority-filter .filter-button,
  .recommendations .filters-container .filter-section .type-filter .filter-button,
  .recommendations .filters-container .filter-section .attempt-filter .filter-button {
    padding: 6px 12px;
    font-size: 12px;
  }
  .recommendations .topic-card .topic-card-body {
    padding: 12px;
  }
  .recommendations .topic-card .topic-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .recommendations .topic-card .topic-header .topic-name {
    font-size: 16px;
    max-width: 100%;
  }
  .recommendations .topic-card .topic-header .completion-info {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    gap: 8px;
  }
  .recommendations .topic-card .topic-header .completion-info .completion-badge {
    font-size: 12px;
    padding: 3px 6px;
  }
  .recommendations .topic-card .topic-header .completion-info .progress-container {
    width: 100%;
    min-width: 0;
    height: 6px;
  }
  .recommendations .topic-card .content-sections .section-header {
    padding: 6px;
  }
  .recommendations .topic-card .content-sections .section-header .section-title h4 {
    font-size: 13px;
  }
  .recommendations .topic-card .content-sections .section-header .section-toggle .toggle-icon {
    font-size: 14px;
  }
  .recommendations .topic-card .content-sections .items-container {
    max-height: 300px;
  }
  .recommendations .topic-card .content-sections .items-container .item {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    gap: 10px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-right: 0;
    width: 100%;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-name {
    font-size: 12px;
    width: 100%;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-type {
    margin-right: 0;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-type .type-icon {
    font-size: 14px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .item-type .type-label {
    font-size: 11px;
  }
  .recommendations .topic-card .content-sections .items-container .item .item-details .priority-badge,
  .recommendations .topic-card .content-sections .items-container .item .item-details .score-badge {
    font-size: 10px;
    padding: 2px 5px;
  }
  .recommendations .topic-card .content-sections .items-container .item .action-button {
    width: 100%;
    padding: 8px;
    font-size: 12px;
    text-align: center;
  }
}
@media (max-width: 576px) {
  .recommendations {
    padding: 10px;
  }
  .recommendations .section-header {
    margin-bottom: 12px;
  }
  .recommendations .section-header h2 {
    font-size: 16px;
  }
  .recommendations .section-header p {
    font-size: 12px;
  }
  .recommendations .recommendations-tabs {
    gap: 6px;
    margin-bottom: 12px;
  }
  .recommendations .recommendations-tabs .tab-button {
    padding: 5px 8px;
    font-size: 12px;
  }
  .recommendations .filters-container {
    padding: 10px;
  }
  .recommendations .filters-container .filter-section .filter-label {
    font-size: 12px;
  }
  .recommendations .filters-container .filter-section .priority-filter .filter-button,
  .recommendations .filters-container .filter-section .type-filter .filter-button,
  .recommendations .filters-container .filter-section .attempt-filter .filter-button {
    padding: 5px 10px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/Diagnostic/components/Recommendations/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EAuaA,6BAAA;EA8GA,4BAAA;EAmKA,gCAAA;AAnrBF;AAHE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAKJ;AAHI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAKN;AAFI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAIN;AAAE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AAEJ;AAAI;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAEN;AAAM;EACE,cAAA;AAER;AACM;EACE,cAAA;EACA,gBAAA;AACR;AACQ;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AACV;AAKE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAHJ;AAME;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,qDAAA;AAJJ;AAMI;EACE,2BAAA;EACA,0CAAA;AAJN;AAOI;EACE,aAAA;AALN;AAQI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;AANN;AAQM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,cAAA;AANR;AASM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAPR;AASQ;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAPV;AASU;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;AAPZ;AAWQ;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AATV;AAWU;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;AATZ;AAWY;EACE,mBAAA;AATd;AAiBM;EACE,mBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sCAAA;AAfV;AAiBU;EACE,yBAAA;AAfZ;AAmBY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAjBd;AAsBY;EACE,cAAA;EACA,+BAAA;AApBd;AAyBQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;AAvBV;AAyBU;EACE,UAAA;AAvBZ;AA0BU;EACE,mBAAA;EACA,kBAAA;AAxBZ;AA2BU;EACE,mBAAA;EACA,kBAAA;AAzBZ;AA4BU;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,yBAAA;AA1BZ;AA4BY;EACE,2BAAA;EACA,wCAAA;EACA,qBAAA;AA1Bd;AA6BY;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AA3Bd;AA6Bc;EARF;IASI,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;EA1Bd;AACF;AA4Bc;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AA1BhB;AA4BgB;EATF;IAUI,WAAA;IACA,kBAAA;EAzBhB;AACF;AA4Bc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA1BhB;AA4BgB;EALF;IAMI,uBAAA;EAzBhB;AACF;AA2BgB;EACE,eAAA;EACA,cAAA;AAzBlB;AA4BgB;EACE,eAAA;EACA,cAAA;AA1BlB;AA8Bc;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA5BhB;AA8BgB;EACE,yBAAA;EACA,cAAA;AA5BlB;AA+BgB;EACE,yBAAA;EACA,cAAA;AA7BlB;AAgCgB;EACE,yBAAA;EACA,cAAA;AA9BlB;AAkCc;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAhChB;AAkCgB;EACE,cAAA;EACA,gBAAA;AAhClB;AAqCY;EACE,gBAAA;EACA,mBAAA;AAnCd;AAqCc;EAJF;IAKI,WAAA;IACA,gBAAA;EAlCd;AACF;AA0CE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAxCJ;AA2CM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAzCR;AA6CI;EACE,0BAAA;EACA,SAAA;EACA,aAAA;AA3CN;AA+CE;;;EAGE,aAAA;EACA,eAAA;EACA,QAAA;AA7CJ;AA+CI;;;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3CN;AA6CM;;;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;AAzCR;AA4CM;;;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAxCR;AA8CI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AA5CN;AAgDM;EACE,gCAAA;AA9CR;AAgDQ;EACE,mBAAA;AA9CV;AAkDU;EACE,qBAAA;AAhDZ;AAmDU;EACE,qBAAA;EACA,cAAA;AAjDZ;AAmDY;EACE,mBAAA;EACA,YAAA;EACA,4CAAA;AAjDd;AAyDE;EACE;IAAK,4BAAA;EAtDP;EAuDE;IAAO,2BAAA;EApDT;AACF;AAuDE;EAjbF;IAkbI,aAAA;IACA,eAAA;EApDF;EAsDE;IACE,mBAAA;EApDJ;EAsDI;IACE,eAAA;EApDN;EAuDI;IACE,eAAA;EArDN;EAyDE;IACE,SAAA;IACA,mBAAA;EAvDJ;EAyDI;IACE,iBAAA;IACA,eAAA;EAvDN;EA2DE;IACE,qCAAA;IACA,SAAA;IACI,aAAA;EAzDR;EA6DI;IACE,aAAA;EA3DN;EA+DM;IACE,eAAA;IACA,cAAA;EA7DR;EAgEM;IACE,gBAAA;IACA,SAAA;EA9DR;EAgEQ;IACE,eAAA;IACA,gBAAA;EA9DV;EAiEQ;IACE,eAAA;IACA,WAAA;EA/DV;EAqEM;IACE,YAAA;EAnER;EAqEQ;IACE,eAAA;EAnEV;EAwEQ;IACE,aAAA;EAtEV;EAwEU;IACE,SAAA;IACA,kBAAA;EAtEZ;EAwEY;IACE,eAAA;EAtEd;EAyEY;IACE,kBAAA;EAvEd;EAyEc;IACE,eAAA;EAvEhB;EA0Ec;IACR,eAAA;EAxEN;EA4EY;;IAEE,eAAA;IACA,gBAAA;EA1Ed;EA8EU;IACE,iBAAA;IACA,eAAA;EA5EZ;AACF;AAoFE;EA/hBF;IAgiBI,aAAA;EAjFF;EAmFE;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,mBAAA;EAjFJ;EAmFI;IACE,eAAA;EAjFN;EAoFI;IACE,eAAA;EAlFN;EAsFE;IACE,QAAA;IACA,mBAAA;IACA,gBAAA;IACA,qBAAA;IACA,wBAAA;EApFJ;EAsFI;IACE,aAAA;EApFN;EAuFI;IACE,iBAAA;IACA,eAAA;IACA,mBAAA;EArFN;EAuFM;IACE,YAAA;EArFR;EA0FE;IACE,aAAA;EAxFJ;EA2FM;IACE,eAAA;IACA,kBAAA;EAzFR;EA4FM;;;IAGE,QAAA;EA1FR;EA4FQ;;;IACE,iBAAA;IACA,eAAA;EAxFV;EA+FI;IACE,aAAA;EA7FN;EAgGI;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EA9FN;EAgGM;IACE,eAAA;IACA,eAAA;EA9FR;EAiGM;IACE,WAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;IACA,QAAA;EA/FR;EAiGQ;IACE,eAAA;IACA,gBAAA;EA/FV;EAkGQ;IACE,WAAA;IACA,YAAA;IACA,WAAA;EAhGV;EAsGQ;IACA,YAAA;EApGR;EAsGQ;IACE,eAAA;EApGV;EAuGQ;IACE,eAAA;EArGV;EAyGQ;IACA,iBAAA;EAvGR;EAyGU;IACA,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,SAAA;EAvGV;EAyGY;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,eAAA;IACA,WAAA;EAvGZ;EAyGc;IACA,eAAA;IACA,WAAA;EAvGd;EA0Gc;IACA,eAAA;EAxGd;EA0GgB;IACA,eAAA;EAxGhB;EA2GgB;IACA,eAAA;EAzGhB;EA6GY;;IAEE,eAAA;IACA,gBAAA;EA3Gd;EA+GY;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,kBAAA;EA7GZ;AACF;AAqHE;EAlsBF;IAmsBI,aAAA;EAlHF;EAoHE;IACE,mBAAA;EAlHJ;EAoHI;IACE,eAAA;EAlHN;EAqHI;IACE,eAAA;EAnHN;EAuHE;IACE,QAAA;IACA,mBAAA;EArHJ;EAuHI;IACE,gBAAA;IACA,eAAA;EArHN;EAyHE;IACE,aAAA;EAvHJ;EA0HM;IACE,eAAA;EAxHR;EA8HQ;;;IACE,iBAAA;IACA,eAAA;EA1HV;AACF","sourcesContent":[".recommendations {\n  position: relative;\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: visible;\n  margin-top: 20px;\n\n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 24px;\n    position: relative;\n\n    h2 {\n      font-size: 24px;\n      font-weight: 600;\n      color: #1e293b;\n      margin: 0;\n    }\n\n    p {\n      font-size: 16px;\n      color: #64748b;\n      margin: 4px 0 0;\n    }\n  }\n\n  .recommendations-tabs {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 24px;\n    border-bottom: 2px solid #e2e8f0;\n    padding-bottom: 8px;\n\n    .tab-button {\n      padding: 8px 16px;\n      border: none;\n      background: none;\n      font-size: 16px;\n      font-weight: 500;\n      color: #64748b;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      position: relative;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      &:hover {\n        color: #2563eb;\n      }\n\n      &.active {\n        color: #2563eb;\n        font-weight: 600;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          bottom: -10px;\n          left: 0;\n          width: 100%;\n          height: 2px;\n          background-color: #2563eb;\n        }\n      }\n    }\n  }\n\n  .topics-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    width: 100%;\n  }\n\n  .topic-card {\n    width: 100%;\n    border: none;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n    &:hover {\n      transform: translateY(-5px);\n      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n    }\n\n    .topic-card-body {\n      padding: 20px;\n    }\n\n    .topic-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 20px;\n      padding-bottom: 15px;\n      border-bottom: 1px solid #e0e0e0;\n\n      .topic-name {\n        font-size: 20px;\n        font-weight: 600;\n        color: #2c3e50;\n        margin: 0;\n        max-width: 60%;\n      }\n\n      .completion-info {\n        display: flex;\n        align-items: center;\n        gap: 15px;\n        min-width: 200px;\n\n        .completion-badge {\n          background-color: #f8f9fa;\n          padding: 5px 10px;\n          border-radius: 5px;\n          font-size: 14px;\n          color: #7f8c8d;\n          white-space: nowrap;\n\n          &.champion {\n            background-color: #e8f5e9;\n            color: #2e7d32;\n            font-weight: 600;\n          }\n        }\n\n        .progress-container {\n          flex: 1;\n          min-width: 100px;\n          height: 10px;\n          background-color: #e9ecef;\n          border-radius: 5px;\n          overflow: hidden;\n          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n\n          .progress-fill {\n            height: 100%;\n            background: #3498db;\n            border-radius: 5px;\n            transition: width 0.5s ease-in-out;\n\n            &.champion {\n              background: #2e7d32;\n            }\n          }\n        }\n      }\n    }\n\n    .content-sections {\n      .content-section {\n        margin-bottom: 15px;\n\n        .section-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          padding: 10px;\n          background-color: #f8f9fa;\n          border-radius: 5px;\n          cursor: pointer;\n          transition: background-color 0.3s ease;\n\n          &:hover {\n            background-color: #f0f0f0;\n          }\n\n          .section-title {\n            h4 {\n              font-size: 16px;\n              font-weight: 500;\n              color: #2c3e50;\n              margin: 0;\n            }\n          }\n\n          .section-toggle {\n            .toggle-icon {\n              color: #7f8c8d;\n              transition: transform 0.3s ease;\n            }\n          }\n        }\n\n        .items-container {\n          margin-top: 10px;\n          padding: 0 10px;\n          max-height: 400px;\n          overflow-y: auto;\n          scrollbar-width: thin;\n          scrollbar-color: #3498db #f0f0f0;\n\n          &::-webkit-scrollbar {\n            width: 6px;\n          }\n\n          &::-webkit-scrollbar-track {\n            background: #f0f0f0;\n            border-radius: 3px;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background: #3498db;\n            border-radius: 3px;\n          }\n\n          .item {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 15px;\n            background-color: #fff;\n            border-radius: 8px;\n            margin-bottom: 10px;\n            border: 1px solid #e0e0e0;\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n            transition: all 0.3s ease;\n\n            &:hover {\n              transform: translateY(-2px);\n              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n              border-color: #3498db;\n            }\n\n            .item-details {\n              display: flex;\n              align-items: center;\n              gap: 15px;\n              flex: 1;\n              min-width: 0;\n              margin-right: 20px;\n\n              @media (max-width: 767px) {\n                flex-direction: column;\n                align-items: center;\n                text-align: center;\n                gap: 8px;\n                margin-right: 0;\n              }\n\n              .item-name {\n                font-size: 14px;\n                color: #2c3e50;\n                font-weight: 500;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                flex: 1;\n\n                @media (max-width: 767px) {\n                  width: 100%;\n                  text-align: center;\n                }\n              }\n\n              .item-type {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n\n                @media (max-width: 767px) {\n                  justify-content: center;\n                }\n\n                .type-icon {\n                  font-size: 18px;\n                  color: #3498db;\n                }\n\n                .type-label {\n                  font-size: 14px;\n                  color: #7f8c8d;\n                }\n              }\n\n              .priority-badge {\n                padding: 4px 8px;\n                border-radius: 4px;\n                font-size: 12px;\n                font-weight: 500;\n                white-space: nowrap;\n\n                &.high {\n                  background-color: #fee2e2;\n                  color: #dc2626;\n                }\n\n                &.medium {\n                  background-color: #fef3c7;\n                  color: #d97706;\n                }\n\n                &.low {\n                  background-color: #e0f2fe;\n                  color: #0284c7;\n                }\n              }\n\n              .score-badge {\n                font-size: 14px;\n                color: #7f8c8d;\n                white-space: nowrap;\n\n                &.champion {\n                  color: #2e7d32;\n                  font-weight: 600;\n                }\n              }\n            }\n\n            .action-button {\n              min-width: 100px;\n              white-space: nowrap;\n\n              @media (max-width: 767px) {\n                width: 100%;\n                margin-top: 10px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .filters-container {\n    background: #f8f9fa;\n    padding: 20px;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    margin-bottom: 30px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n\n    .filter-section {\n      .filter-label {\n        font-size: 14px;\n        font-weight: 600;\n        color: #495057;\n        margin-bottom: 10px;\n      }\n    }\n\n    &.mobile-filters {\n      grid-template-columns: 1fr;\n      gap: 15px;\n      padding: 15px;\n    }\n  }\n\n  .priority-filter,\n  .type-filter,\n  .attempt-filter {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    .filter-button {\n      padding: 8px 16px;\n      border: 1px solid #e9ecef;\n      border-radius: 8px;\n      background: #fff;\n      color: #495057;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: #f8f9fa;\n        border-color: #dee2e6;\n        transform: translateY(-1px);\n      }\n\n      &.active {\n        background: #007bff;\n        color: #fff;\n        border-color: #007bff;\n      }\n    }\n  }\n\n  .champion-topics {\n    .topics-container {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      width: 100%;\n    }\n\n    .topic-card {\n      .items-container {\n        scrollbar-color: #2e7d32 #f0f0f0;\n\n        &::-webkit-scrollbar-thumb {\n          background: #2e7d32;\n        }\n\n        .item {\n          &:hover {\n            border-color: #2e7d32;\n          }\n\n          .action-button {\n            border-color: #2e7d32;\n            color: #2e7d32;\n\n            &:hover {\n              background: #2e7d32;\n              color: white;\n              box-shadow: 0 4px 8px rgba(46, 125, 50, 0.2);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @keyframes shimmer {\n    0% { transform: translateX(-100%); }\n    100% { transform: translateX(100%); }\n  }\n\n  /* Tablet screens (≤1024px) */\n  @media (max-width: 1024px) {\n    padding: 15px;\n    max-width: 100%;\n\n    .section-header {\n      margin-bottom: 20px;\n\n      h2 {\n        font-size: 20px;\n      }\n\n      p {\n        font-size: 14px;\n      }\n    }\n\n    .recommendations-tabs {\n      gap: 12px;\n      margin-bottom: 20px;\n\n      .tab-button {\n        padding: 6px 12px;\n        font-size: 14px;\n      }\n    }\n\n    .filters-container {\n      grid-template-columns: repeat(2, 1fr);\n      gap: 15px;\n          padding: 15px;\n    }\n\n    .topic-card {\n      .topic-card-body {\n        padding: 15px;\n      }\n\n      .topic-header {\n        .topic-name {\n          font-size: 18px;\n          max-width: 50%;\n        }\n\n        .completion-info {\n          min-width: 150px;\n          gap: 10px;\n\n          .completion-badge {\n            font-size: 12px;\n            padding: 4px 8px;\n          }\n\n          .progress-container {\n            min-width: 80px;\n            height: 8px;\n          }\n        }\n      }\n\n      .content-sections {\n        .section-header {\n          padding: 8px;\n\n          .section-title h4 {\n            font-size: 14px;\n          }\n        }\n\n        .items-container {\n          .item {\n            padding: 12px;\n\n            .item-details {\n              gap: 10px;\n              margin-right: 15px;\n\n              .item-name {\n                font-size: 13px;\n              }\n\n              .item-type {\n                margin-right: 10px;\n\n                .type-icon {\n                  font-size: 16px;\n                }\n\n                .type-label {\n        font-size: 12px;\n                }\n              }\n\n              .priority-badge,\n      .score-badge {\n                font-size: 11px;\n                padding: 3px 6px;\n              }\n            }\n\n            .action-button {\n              padding: 6px 12px;\n              font-size: 13px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  /* Mobile screens (≤767px) */\n  @media (max-width: 767px) {\n    padding: 12px;\n\n    .section-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n      margin-bottom: 16px;\n\n      h2 {\n        font-size: 18px;\n      }\n\n      p {\n        font-size: 13px;\n      }\n    }\n\n    .recommendations-tabs {\n      gap: 8px;\n      margin-bottom: 16px;\n      overflow-x: auto;\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .tab-button {\n        padding: 6px 10px;\n        font-size: 13px;\n        white-space: nowrap;\n\n        &.active::after {\n          bottom: -8px;\n        }\n      }\n    }\n\n    .filters-container {\n      padding: 12px;\n\n      .filter-section {\n        .filter-label {\n          font-size: 13px;\n          margin-bottom: 8px;\n        }\n\n        .priority-filter,\n        .type-filter,\n        .attempt-filter {\n          gap: 6px;\n\n          .filter-button {\n            padding: 6px 12px;\n            font-size: 12px;\n          }\n        }\n      }\n    }\n\n    .topic-card {\n      .topic-card-body {\n        padding: 12px;\n      }\n\n      .topic-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n\n        .topic-name {\n          font-size: 16px;\n          max-width: 100%;\n        }\n\n        .completion-info {\n          width: 100%;\n          flex-direction: column;\n          align-items: flex-start;\n          min-width: 0;\n          gap: 8px;\n\n          .completion-badge {\n            font-size: 12px;\n            padding: 3px 6px;\n          }\n\n          .progress-container {\n            width: 100%;\n            min-width: 0;\n            height: 6px;\n          }\n        }\n      }\n\n      .content-sections {\n          .section-header {\n          padding: 6px;\n\n          .section-title h4 {\n            font-size: 13px;\n          }\n\n          .section-toggle .toggle-icon {\n            font-size: 14px;\n            }\n          }\n\n          .items-container {\n          max-height: 300px;\n\n            .item {\n            flex-direction: column;\n            align-items: flex-start;\n            padding: 10px;\n            gap: 10px;\n\n              .item-details {\n              flex-direction: column;\n              align-items: flex-start;\n              gap: 8px;\n              margin-right: 0;\n              width: 100%;\n\n                .item-name {\n                font-size: 12px;\n                width: 100%;\n                }\n\n                .item-type {\n                margin-right: 0;\n\n                  .type-icon {\n                  font-size: 14px;\n                  }\n\n                  .type-label {\n                  font-size: 11px;\n                }\n              }\n\n              .priority-badge,\n              .score-badge {\n                font-size: 10px;\n                padding: 2px 5px;\n                }\n              }\n\n              .action-button {\n              width: 100%;\n              padding: 8px;\n              font-size: 12px;\n              text-align: center;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  /* Very small screens (≤576px) */\n  @media (max-width: 576px) {\n    padding: 10px;\n\n    .section-header {\n      margin-bottom: 12px;\n\n      h2 {\n        font-size: 16px;\n      }\n\n      p {\n        font-size: 12px;\n      }\n    }\n\n    .recommendations-tabs {\n      gap: 6px;\n      margin-bottom: 12px;\n\n      .tab-button {\n        padding: 5px 8px;\n        font-size: 12px;\n      }\n    }\n\n    .filters-container {\n      padding: 10px;\n\n      .filter-section {\n        .filter-label {\n          font-size: 12px;\n      }\n\n      .priority-filter,\n      .type-filter,\n      .attempt-filter {\n          .filter-button {\n            padding: 5px 10px;\n            font-size: 11px;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
